import { PurchaseDetail, PurchaseFormValues } from "../../../types/purchases/BasePurchase";

export function mapExcludedSubject(purchase: PurchaseDetail): PurchaseFormValues {
  const excluded = purchase.excludedSubjectDetails;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    correlative: purchase.correlative,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',

    products: excluded?.products || [],

    paymentCondition: purchase.paymentCondition || null,


    // Totales personalizados para Sujeto Excluido
    taxableSubtotal: null,
    perceivedIVA: null,
    totalToRefund: null,
    withheldIVA: excluded?.incomeTaxWithholding ?? 0,

    subtotal: excluded?.subtotal ?? 0,
    total: excluded?.total ?? 0,
  };
}
